import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Product } from '../models/product.model';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    getTopProducts(limit: number): Observable<Product[]> {
        const products: Product[] = [];
        for (let i = 1; i <= limit; i++) {
            const fakeProduct: Product = {
                name: `Wzór ${Math.floor(Math.random() * 100)}`,
                description: '10-12g | 5mm',
                image: { url: `/assets/images/products/product_${i}.png` },
            };
            products.push(fakeProduct);
        }
        return of(products);
    }
}
